/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AdGroupDetailSearchOrderBy {
    Name = 'Name',
    Roles = 'Roles',
    Permissions = 'Permissions'
}


export function instanceOfAdGroupDetailSearchOrderBy(value: any): boolean {
    for (const key in AdGroupDetailSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(AdGroupDetailSearchOrderBy, key)) {
            if (AdGroupDetailSearchOrderBy[key as keyof typeof AdGroupDetailSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdGroupDetailSearchOrderByFromJSON(json: any): AdGroupDetailSearchOrderBy {
    return AdGroupDetailSearchOrderByFromJSONTyped(json, false);
}

export function AdGroupDetailSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdGroupDetailSearchOrderBy {
    return json as AdGroupDetailSearchOrderBy;
}

export function AdGroupDetailSearchOrderByToJSON(value?: AdGroupDetailSearchOrderBy | null): any {
    return value as any;
}

export function AdGroupDetailSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): AdGroupDetailSearchOrderBy {
    return value as AdGroupDetailSearchOrderBy;
}

